import React from 'react';
import { Link } from 'react-router-dom';
import { VERSION } from '../utils/version';

const Footer: React.FC = () => {
  // Version is read directly from package.json at build time
  const version = VERSION;

  return (
    <footer className="bg-gray-800 dark:bg-gray-950 text-white py-6 mt-auto border-t border-gray-700 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-8 px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-sm text-gray-300 dark:text-gray-400">
            <span className="font-semibold">Version {version}</span>
          </div>
          <div className="flex gap-4 text-sm items-center">
            <Link 
              to="/changelog" 
              className="text-secondary-400 dark:text-secondary-300 hover:text-accent-400 dark:hover:text-accent-300 transition-colors duration-200 font-medium"
            >
              Changelog
            </Link>
            <span className="text-gray-600 dark:text-gray-500">•</span>
            <span className="text-gray-400 dark:text-gray-500">
              © {new Date().getFullYear()} Akhile Digital
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
